import {
  evidenceDefinitionDataSchema,
  type EvidenceListResponseDto,
} from "@clipboard-health/contract-documents-service";
import { type z } from "zod";

export type EvidenceDefinition = z.infer<typeof evidenceDefinitionDataSchema>;

export type EvidenceData = EvidenceListResponseDto["data"][number];

export interface JsonSchemaProperty {
  type?: string;
  format?: string;
  enum?: string[];
  description?: string;
  properties?: Record<string, JsonSchemaProperty>;
  required?: string[];
}

export interface JsonSchema {
  type?: string;
  properties?: Record<string, JsonSchemaProperty>;
  required?: string[];
}

export function toJsonSchema(value: Record<string, unknown>): JsonSchema {
  return value as JsonSchema;
}
